import ReviewsListInfoStoreBase from "@apps/reviews/stores/ReviewsListInfoStoreBase";

class ReviewsListInfoStore extends ReviewsListInfoStoreBase {}

export default ReviewsListInfoStore;
